import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.669 2.415A.75.75 0 0 1 6.339 2h2.822c.284 0 .544.16.67.415L10 2.75h2.25a.75.75 0 1 1 0 1.5h-9a.75.75 0 1 1 0-1.5H5.5zM3.25 5h9v7.5c0 .827-.673 1.5-1.5 1.5h-6c-.827 0-1.5-.673-1.5-1.5zM5.5 6.5a.376.376 0 0 0-.375.375v5.25c0 .206.169.375.375.375a.376.376 0 0 0 .375-.375v-5.25A.376.376 0 0 0 5.5 6.5m2.25 0a.376.376 0 0 0-.375.375v5.25c0 .206.169.375.375.375a.376.376 0 0 0 .375-.375v-5.25A.376.376 0 0 0 7.75 6.5m2.25 0a.376.376 0 0 0-.375.375v5.25c0 .206.169.375.375.375a.376.376 0 0 0 .375-.375v-5.25A.376.376 0 0 0 10 6.5"
    }, null, -1)
  ]))]))
}
export default { render: render }